export default {
  setRows(state, data) {
    state.rows = data
  },
}

